export const updateBlogPost = async (postId, updatedData) => {
    try {
        const response = await fetch(`https://blog-swipe-backend.vercel.app/${postId}`, {  // Fixed: Include postId in the URL
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedData,postId),
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to update post');
        }

        const result = await response.json();
        console.log(result); // Log success or updated post info
        return result; // Return updated post data
    } catch (error) {
        console.error('Error updating post:', error);
        throw error;
    }
};
